module.exports = __webpack_public_path__ + "img/CZ49279866.3e9bba32.png";